"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var reconfigureButtonStyles_1 = require("./reconfigureButtonStyles");
var DefaultButton_1 = require("../../../../../../common/components/presentation/Buttons/DefaultButton");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var ButtonWithArrow_1 = require("../../../../../../common/components/presentation/Buttons/ButtonWithArrow");
var ReconfigureButton = function (_a) {
    var changeConfiguration = _a.changeConfiguration;
    var _b, _c;
    var styles = reconfigureButtonStyles_1.default();
    var _d = core_1.useTheme().checkoutLite, isFromAltSpc = _d.isFromAltSpc, summary = _d.summary;
    if (isFromAltSpc) {
        return (<core_1.Box justifyContent="center" display="flex" className={styles.buttonContainer}>
        <DefaultButton_1.default labelClasses={styles.btnLabel} className={[styles.reconfigureBtn]} variant="outlined" dataTest="summary:button:change_configuration" onClick={changeConfiguration}>
          <Translation_1.default id={'trans__checkout__vehicle_details__modify_configuration_button'}/>
        </DefaultButton_1.default>
      </core_1.Box>);
    }
    return (<core_1.Box className={styles.buttonWithArrowContainer}>
      <ButtonWithArrow_1.default iconClasses={((_b = summary) === null || _b === void 0 ? void 0 : _b.hideButtonIcon) ? styles.buttonHideIcon : ''} className={((_c = summary) === null || _c === void 0 ? void 0 : _c.hideButtonIcon) ? styles.buttonNoRadius : styles.buttonReconfigure} data-test="summary:button:change_configuration" onClick={changeConfiguration}>
        <core_1.Typography component="span">
          <Translation_1.default id={'trans__checkout__vehicle_details__modify_configuration_button'}/>
        </core_1.Typography>
      </ButtonWithArrow_1.default>
    </core_1.Box>);
};
exports.default = ReconfigureButton;
